

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Loading from "../../PrivacyPolicy/Loading";
import icon1 from "../../../assets/used-icons/about-1.svg";
import icon2 from "../../../assets/used-icons/about-2.svg";
import icon3 from "../../../assets/used-icons/about-3.svg";
import icon4 from "../../../assets/used-icons/about-4.svg";
import { useLanguage } from "../../../store/language-context";
// import useHomeSection from "../../../hooks/useHomeSection";
import { useTranslation } from "react-i18next";

const StatsNumbers = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  // const { } = useHomeSection({ sectionName:'ivory_numbers'})
  const [statsData, setStatsData] = useState([]);
  const [description, setDescription] = useState("");
  const hasAnimated = useRef(false); // Prevent multiple animations
  const icons = [icon4, icon3, icon2, icon1];

  useEffect(() => {
    const fetchStatsData = async () => {
      try {
        const response = await axios.get(
          `${URL}/home-pages?title_section=ivory_numbers`
        );
        if (response.data.status === 200) {
          const data = response.data.data.data;
          const description = response.data.data.description || "";
          setStatsData(
            data.map((item) => ({
              ...item,
              animatedNumber: 0, // Start from 0
            }))
          );
          setDescription(stripHtml(description));
        }
      } catch (error) {
        console.error("Error fetching stats data:", error);
      }
    };

    fetchStatsData();
  }, [URL]);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasAnimated.current && window.scrollY > 1000) {
        hasAnimated.current = true; // Prevent multiple animations
        statsData.forEach((item, index) => {
          animateNumber(index, parseInt(item.sub_title, 10));
        });
        window.removeEventListener("scroll", handleScroll); // Remove event listener after animation starts
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [statsData]);

  const animateNumber = (index, targetNumber) => {
    const duration = 3000; // 3 seconds
    const interval = 10; // Smooth transition
    const steps = duration / interval;
    const increment = targetNumber / steps;

    const counter = setInterval(() => {
      setStatsData((prevData) => {
        const newData = [...prevData];

        // Increase number to target
        if (newData[index].animatedNumber < targetNumber) {
          newData[index].animatedNumber = Math.min(
            newData[index].animatedNumber + increment,
            targetNumber
          );
        } else {
          clearInterval(counter); // Stop animation at the target number
        }

        return newData;
      });
    }, interval);
  };

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  if (statsData.length === 0) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  // const getIcon = (title) => {
  //   if (title.includes("برنامج تدريبي")) return icon4;
  //   if (title.includes("ساعة تدريبية")) return icon3;
  //   if (title.includes("مدرب محترف")) return icon2;
  //   if (title.includes("مشارك")) return icon1;
  //   return null;
  // };

  return (
    <div style={styles.statscard}>
      <div className="container">
        <h2 style={styles.title} className="section-title h-1">
          {t('home.ivory-numbers')}
        </h2>
        {description && <p style={styles.description}>{description}</p>}
        <div style={styles.stats} className="row justify-content-between align-items-center">
          {statsData.map((item, index) => (
            <div
              key={item.id || index}
              style={styles.stat}
              className="col-lg-2 number-part col-md-5 col-12 flex flex-col items-center"
            >
              <div style={styles.iconWrapper}>
                <img src={icons[index]} alt={item.title} style={styles.icon} />
              </div>
              <h3 style={styles.number}>{Math.floor(item.animatedNumber)}</h3>
              <p style={styles.label}>{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  statscard: {
    background: "#6A2F38",
    color: "#fff",
    padding: "20px 20px",
    textAlign: "center",
  },
  container: {
    margin: "0 auto",
  },
  stat: {

    margin: "  10px",
    padding: "10px",
    color: "#9b1c2d",
    borderRadius: "8px",
    textAlign: "center",
  },
  number: {
    fontSize: "1.4rem",
    marginTOP: "5px",
    color: "#D4AD89",
    fontWeight: "bold",
    transition: "ease-in-out 0.5s",
  },
  label: {
    marginBottom: "0",
    fontSize: "1.2rem",
    color: "#fff",
  },
  description: {
    marginBottom: "0px",
    fontSize: "20px",
  },
  iconWrapper: {
    marginBottom: "10px",
  },
  icon: {},
};

export default StatsNumbers;
